import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/markets/page.tsx");
